import { SeaReferenceTypesDTO, SeaRouteTypesDTO, ShipmentStatusesDTO } from "entities/shared/seaCard.types";
import { CoordinateModelDTO, DateTimeDTO } from "entities/shared/shipmentCard.types";
import { ValueOf } from "shared/lib/typeCheck.lib";

export type SealineNameDTO = string;

export type SavedShipmentUUIDDTO = string | null;

export interface SavedShipmentResponseDataDTO {
  id: number;
  profile: number;
  reference: string; // ! (Uppercase ?)
  type: ValueOf<typeof SeaReferenceTypesDTO>; // null ?
  carrier_scac: string; // ! (Uppercase ?)
  carrier_name: string; // !
  shipment_uuid: SavedShipmentUUIDDTO; //^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$ // !
  snapshot_uuid: string | null; //^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$ // !
  status: ValueOf<typeof ShipmentStatusesDTO>;
  equipments_count: number;
  location: {
    from: string | null; // Odessa, UA, POL/POD from overview
    to: string | null; // Odessa, UA, POL/POD from overview
    transport: ValueOf<typeof SeaRouteTypesDTO> | null;
    pin: CoordinateModelDTO | null;
    // from: string; // Odessa, UA, POL/POD from overview
    // to: string; // Odessa, UA, POL/POD from overview
    // transport: TrackingRouteTypes;
    // pin_type: string; // will be added later
  };
  date: {
    from: DateTimeDTO | null; // POL.date.actual ?? POL.date.estimated
    from_actual: boolean; // !!POL.date.actual (POL.date.actual !== null)
    to: DateTimeDTO | null; // POD.date.actual ?? POD.date.estimated
    to_actual: boolean; // !!POD.date.actual (POD.date.actual !== null)
    to_predictive: DateTimeDTO | null;
  };
  tags: string[];
  snapshot_created_at: null | string;
  created_at: string;
  updated_at: string;
  size_type: string | null;
}

export type CountByStatusDTO = {
  status: ValueOf<typeof ShipmentStatusesDTO>;
  count: number;
};

export interface SavedShipmentResponseDTO {
  total_count: number;
  cards: SavedShipmentResponseDataDTO[];
  count_by_status: CountByStatusDTO[];
}

export interface UpdateCardsResponseDTO extends Omit<SavedShipmentResponseDTO, "cards"> {
  total_count: number;
  cards: [];
}

export interface DeleteCardResponseDTO {
  deleted: boolean;
}
